/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDiscreteNumericListDtoGeometry } from './CreateDiscreteNumericListDtoGeometry';
import {
    CreateDiscreteNumericListDtoGeometryFromJSON,
    CreateDiscreteNumericListDtoGeometryFromJSONTyped,
    CreateDiscreteNumericListDtoGeometryToJSON,
} from './CreateDiscreteNumericListDtoGeometry';

/**
 * 
 * @export
 * @interface CreateDiscreteNumericListDto
 */
export interface CreateDiscreteNumericListDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDiscreteNumericListDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscreteNumericListDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscreteNumericListDto
     */
    setupParameterId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscreteNumericListDto
     */
    groupId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDiscreteNumericListDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDiscreteNumericListDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDiscreteNumericListDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscreteNumericListDto
     */
    numericId?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateDiscreteNumericListDto
     */
    selectedValues?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateDiscreteNumericListDto
     */
    availableValues?: Array<number> | null;
    /**
     * 
     * @type {CreateDiscreteNumericListDtoGeometry}
     * @memberof CreateDiscreteNumericListDto
     */
    geometry?: CreateDiscreteNumericListDtoGeometry | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscreteNumericListDto
     */
    $type?: CreateDiscreteNumericListDtoTypeEnum;
}


/**
 * @export
 */
export const CreateDiscreteNumericListDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateDiscreteNumericListDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateDiscreteNumericListDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateDiscreteNumericListDtoTypeEnum = typeof CreateDiscreteNumericListDtoTypeEnum[keyof typeof CreateDiscreteNumericListDtoTypeEnum];



/**
 * Check if a given object implements the CreateDiscreteNumericListDto interface.
 */
export function instanceOfCreateDiscreteNumericListDto(value?: unknown): value is CreateDiscreteNumericListDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateDiscreteNumericListDtoTypeEnum)[0];
}

export function CreateDiscreteNumericListDtoFromJSON(json: any): CreateDiscreteNumericListDto {
    return CreateDiscreteNumericListDtoFromJSONTyped(json, false);
}

export function CreateDiscreteNumericListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDiscreteNumericListDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': json['dataTypeId'] == null ? undefined : json['dataTypeId'],
        'setupParameterId': json['setupParameterId'] == null ? undefined : json['setupParameterId'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'isReadonly': json['isReadonly'] == null ? undefined : json['isReadonly'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'numericId': json['numericId'] == null ? undefined : json['numericId'],
        'selectedValues': json['selectedValues'] == null ? undefined : json['selectedValues'],
        'availableValues': json['availableValues'] == null ? undefined : json['availableValues'],
        'geometry': json['geometry'] == null ? undefined : CreateDiscreteNumericListDtoGeometryFromJSON(json['geometry']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateDiscreteNumericListDtoToJSON(value?: CreateDiscreteNumericListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'dataTypeId': value['dataTypeId'],
        'setupParameterId': value['setupParameterId'],
        'groupId': value['groupId'],
        'isRequired': value['isRequired'],
        'isReadonly': value['isReadonly'],
        'isEnabled': value['isEnabled'],
        'numericId': value['numericId'],
        'selectedValues': value['selectedValues'],
        'availableValues': value['availableValues'],
        'geometry': CreateDiscreteNumericListDtoGeometryToJSON(value['geometry']),
        '$type': value['$type'],
    });
}

